// extracted by mini-css-extract-plugin
export default {"link":"swBnOk1h","isPrimary":"Jz1SC8nz"};